<template>
  <div class="MdBtn" :class="btnClass">
    <a :style="btnStyle">
      <div>{{this.data.action.label}}</div>
    </a>
  </div>
</template>
<script>
export default {
  name: 'lineFlexBtnElement',
  props: {
    data: {
      type: Object,
    },
  },
  computed: {
    btnClass() {
      const cl = {
        ExBtn1: this.data.style === 'primary',
        ExBtn2: this.data.style === 'secondary',
        ExSm: this.data.height === 'sm',
        fl0: this.data.flex === 0,
        fl1: this.data.flex === 1,
        fl2: this.data.flex === 2,
        fl3: this.data.flex === 3,
        grvC: this.data.gravity === 'center',
        grvB: this.data.gravity === 'bottom',
      };
        // Todo add margin handle
      if (!cl.ExBtnL) {
        if (!cl.ExBtn1 && !cl.ExBtn2) {
          cl.ExBtnL = true;
        }
      }
      return cl;
    },
    btnStyle() {
      const style = {};
      if (this.data) {
        if (this.data.color) {
          if (this.data.style === 'primary' || this.data.style === 'secondary') {
            style.backgroundColor = this.data.color;
          } else {
            style.color = this.data.color;
          }
        }
        if (this.data.offsetTop) style.top = this.data.offsetTop;
        if (this.data.offsetBottom) style.bottom = this.data.offsetBottom;
        if (this.data.offsetStart) style.left = this.data.offsetStart;
        if (this.data.offsetEnd) style.right = this.data.offsetEnd;
      }
      return style;
    },
  },
};
</script>
